import React from "react";
import { TContainerStateProps } from "../../state/TContainerStateProps";
import { CRMPageWrap } from "../../components/Simple/CRMPageWrap/CRMPageWrap";
import { CRMLegalMenuBarContainer } from "../../containers/CRMLegalMenuBarContainer/CRMLegalMenuBarContainer";
import { Background } from "../../components/BuildingBlocks/Background";
import { CRMSpacing } from "../../models/CRMSpacing";
import { CRMPadding } from "../../components/Simple/CRMPadding/CRMPadding";
import { CRMSpacingColumn } from "../../components/CRMSpacingColumn/CRMSpacingColumn";
import NotFoundPage from "../NotFoundPage/NotFoundPage";
import { guideProducts } from "../../guides/manifest";
import { generatedGuides } from "../../guides/manifest.generated";
import { isGuidesAccessAllowed } from "./guidesAccess";
import { CRMGuidesHeader } from "../../components/CRM/CRMGuidesHeader/CRMGuidesHeader";

const CRMGuidesPage = (props: TContainerStateProps): JSX.Element => {
    if (!isGuidesAccessAllowed(props.state.global.user.user_role)) {
        return <NotFoundPage state={props.state} dispatch={props.dispatch} />;
    }

    return (
        <CRMPageWrap>
            <CRMLegalMenuBarContainer {...props} />
            <Background padding={`${CRMSpacing.X_LARGE} 0px`}>
                <CRMPadding size="large">
                    <CRMSpacingColumn spacing="large">
                        <CRMGuidesHeader
                            title="Guides"
                            breadcrumbs={[{ label: "Guides" }]}
                        />

                        <div className="crm-guides-page__product-grid">
                            {guideProducts.map((product) => {
                                const count = generatedGuides.filter((g) => g.product === product.id).length;
                                return (
                                    <a
                                        key={product.id}
                                        className="crm-guides-page__product-card"
                                        href={`/crm/guides/${product.id}`}
                                    >
                                        <div className="crm-guides-page__product-title">{product.title}</div>
                                        <div className="crm-guides-page__product-count">
                                            {count === 0 ? "No guides yet" : count === 1 ? "1 guide" : `${count} guides`}
                                        </div>
                                        {count > 0 && <div className="crm-guides-page__product-cta">Browse →</div>}
                                    </a>
                                );
                            })}
                        </div>
                    </CRMSpacingColumn>
                </CRMPadding>
            </Background>
        </CRMPageWrap>
    );
};

export default CRMGuidesPage;
